<script setup lang="ts">
import Title from "@/shared/components/Title/Title.vue";

defineProps<{
  caseNumber: string;
}>();
</script>

<template>
  <div class="successful-registration-note">
    <Title
      size="l"
      :text="$t('registration.user.mobility.successTitle')"
    />
    <i18n-t
      keypath="registration.user.mobility.successNote"
      tag="p"
      scope="global"
    >
      <template #caseNumber>
        <strong>
          {{ caseNumber }}
        </strong>
      </template>
    </i18n-t>
  </div>
</template>

<style scoped>
@import "SuccessfulRegistrationNote.css";
</style>
